import { Link, NavLink, Outlet, useLocation, useMatch } from "react-router-dom";

/**
 * 게임별로 완전히 분리된 두 영역.
 *  - Hide & Seek : 기존 경로 그대로 (/, /analysis, /sessions …) — 원천 D1
 *  - Double Blind: /db/*                                       — 원천 play.fuzzyline.io
 * 헤더의 게임 전환만 공유하고 필터·네비·데이터는 섞지 않는다.
 */
export function Layout() {
  const { pathname } = useLocation();
  const isDb = pathname === "/db" || pathname.startsWith("/db/");
  const isDetail = !!useMatch("/sessions/:id");

  return (
    <div className={`app ${isDb ? "app-db" : "app-has"}`}>
      <header className="app-header">
        <div className="brand">Fuzzyline Stats</div>
        <nav className="game-switch" aria-label="게임 선택">
          <Link to="/" className={!isDb ? "active" : ""} aria-current={!isDb ? "page" : undefined}>
            Hide &amp; Seek
          </Link>
          <Link to="/db" className={isDb ? "active" : ""} aria-current={isDb ? "page" : undefined}>
            Double Blind
          </Link>
        </nav>
        {isDb ? (
          <nav className="app-nav">
            <NavLink to="/db" end>
              개요
            </NavLink>
            <NavLink to="/db/balance">밸런스</NavLink>
            <NavLink to="/db/roles">진영·역할</NavLink>
            <NavLink to="/db/matches">경기</NavLink>
          </nav>
        ) : (
          <nav className="app-nav">
            <NavLink to="/" end>
              개요
            </NavLink>
            <NavLink to="/distribution">분포</NavLink>
            <NavLink to="/analysis">게임 분석</NavLink>
            <NavLink to="/devices">장치</NavLink>
            <NavLink to="/death-locations">생명 손실 위치</NavLink>
            <NavLink to="/detections">발각</NavLink>
            <NavLink to="/sessions">세션</NavLink>
          </nav>
        )}
      </header>
      <main className={`app-main ${isDetail ? "detail-main" : ""}`}>
        <Outlet />
      </main>
    </div>
  );
}
